<template>
    <section class="slider__container">
        <div class="slider__content">
            <div class="text" data-animate="fadeIn" v-if="fields">{{ fields['Title section'] }}</div>
            <div class="desc" data-animate="fadeIn" v-if="fields">{{ fields['Text section'] }}</div>
            <router-link :to="{ name: 'products' }" v-if="fields && fields['Text Button']">{{ fields['Text Button'] }}</router-link>
        </div>
        <Splide :options="mainOptions" :has-track="false" aria-label="My Favorite Images" v-if="fields" data-animate="slideAppear">
            <SplideTrack >
                <SplideSlide  v-for="item in fields['Slider Content']" >
                        <div class="item__slider" >
                            <div class="text">{{item.text}}</div>
                            <img :src="`${this.$store.state.base_directory}${item.image.replace(/^public\//, '')}`" alt="">
                            <a :href="item.link"></a>
                        </div>
                </SplideSlide>
            </SplideTrack>
            <div class="splide__arrows">
                <button class="splide__arrow splide__arrow--prev">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <g id="arrow_right">
                            <path id="Polygon 1"
                                d="M9.29289 13.1191C8.90237 12.7286 8.90237 12.0954 9.29289 11.7049L12.8787 8.11912C13.5086 7.48915 14.5858 7.93532 14.5858 8.82622L14.5858 15.9978C14.5858 16.8887 13.5086 17.3349 12.8787 16.7049L9.29289 13.1191Z"
                                fill="black" />
                        </g>
                    </svg>
                </button>
                <button class="splide__arrow splide__arrow--next">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                        fill="none">
                        <g clip-path="url(#clip0_4587_53887)">
                            <path
                                d="M14.7071 10.8809C15.0976 11.2714 15.0976 11.9046 14.7071 12.2951L11.1213 15.8809C10.4914 16.5108 9.41421 16.0647 9.41421 15.1738L9.41421 8.0022C9.41421 7.1113 10.4914 6.66513 11.1213 7.2951L14.7071 10.8809Z"
                                fill="black" />
                        </g>
                        <defs>
                            <clipPath id="clip0_4587_53887">
                                <rect width="24" height="24" fill="white" />
                            </clipPath>
                        </defs>
                    </svg>
                </button>
            </div>
        </Splide>

    </section>
</template>

<script>
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css';
import '@splidejs/vue-splide/css/skyblue';
import '@splidejs/vue-splide/css/sea-green';
import '@splidejs/vue-splide/css/core';
    export default {
        props: {
          fields: [Array,Object],
        },
        components: { Splide, SplideSlide, SplideTrack },
        data() {
            return {
                mainOptions: {
                    padding: '0px',
                    perPage: 3.2,
                    perMove: 3.2,
                    focus: 0,
                    gap: 24,
                    padding: 0,
                    height: '448px',
                    arrows: true,
                    cover: true,
                    pagination: false,
                    breakpoints: {
                        1024: {
                            perPage: 2.2,
                            perMove: 2.2,
                        },
                        768: {
                            perPage: 1.2,
                            perMove: 1,
                        },
                    },
                },
            }
        },
        mounted() {
            window.addEventListener("scroll", this.crollLeftAnimation);
        },
        beforeUnmount() {
            window.removeEventListener("scroll", this.crollLeftAnimation);
        },
        methods: {
            crollLeftAnimation() { 
                let scrollLeftAnimationElements = document.querySelectorAll(".scrollLeftAnimation");
                scrollLeftAnimationElements.forEach(SectionElement => this.updateAnimation(SectionElement));  
            },
            updateAnimation(SectionElement) {
                let ContentElement = SectionElement.querySelector(".animationContent");
                let y = ContentElement.getBoundingClientRect().y;
                let pourcent = Math.abs(SectionElement.getBoundingClientRect().y / (SectionElement.clientHeight - ContentElement.clientHeight));
                let ContentOverflowElement = SectionElement.querySelector(".animationContentOverflow");
                let ContentOverflowElementLeftScrollDistance = ContentOverflowElement.scrollWidth - ContentOverflowElement.clientWidth;
                let newScrollLeft;
                if (y == 0) {
                    newScrollLeft = ContentOverflowElementLeftScrollDistance * pourcent;
                } else if (y > 0) {
                    newScrollLeft = 0;
                } else {
                    newScrollLeft = ContentOverflowElementLeftScrollDistance;
                }

                // Обновляем scrollLeft только если значение изменилось
                if (ContentOverflowElement.scrollLeft !== newScrollLeft) {
                    ContentOverflowElement.scrollLeft = newScrollLeft;
                }
            }
        }
    }
</script>

<style scoped>
    .scrollLeftAnimation {
    height: 300vh;
    /* display: none; */
    }

    .animationContent {
        position: sticky;
        top: 0;
        height: 100vh;
    }

    .animationContentOverflow {
        overflow: hidden;
        height: 25vh;
    }
    .animationContent ul {
        margin: 0;
        padding: 0;
        height: 100%;
        white-space: nowrap;

    }

    .card {
        border: 1px solid black;
        height: 100%;
        width: 35vw;
        background-color: gray;
        display: inline-block;
    }

    .card + .card {
        margin-left: 50px;
    }

    .card:first-child {
        margin-left: 25px;
    }

    .card:last-child {
        margin-right: 25px;
    }
    /* .card {
        height: 100%;
        width: 100vw;
        background-color: gray;
        display: inline-block;
        position: relative;
        height: 446px;
        background: linear-gradient(180.00deg, rgb(173, 184, 199), rgb(222, 230, 234) 100%);
    }

    .card + .card {
        margin-left: 50px;
    }

    .card .text {
        color: rgb(255, 255, 255);
        font-size: 24px;
        font-weight: 500;
        line-height: 140%;
        letter-spacing: 0%;
        text-align: center;
        padding-top: 27px;
    }
    .card img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 373.5px;
        -o-object-fit: contain;
        object-fit: contain;
    } */


.splide__arrow--prev svg {
    transform: rotate(0deg);
}

.splide__arrow:disabled {
    opacity: 0;
    cursor: not-allowed;
}

.splide__arrow {
    transition: all 0.1s;
    opacity: 1;
    border-radius: 500px;
    border: 1.5px solid rgb(255, 183, 16);
    background: rgb(255, 183, 16);
    backdrop-filter: blur(9.5px);
    width: 40px;
    height: 40px;
}

.splide__arrow svg {
    width: auto;
    height: auto;
}

.item__slider{
    position: relative;
    height: 446px;
    background: linear-gradient(180.00deg, rgb(173, 184, 199),rgb(222, 230, 234) 100%);
}
.splide{
    padding: 0;
    margin-top: 44px;
}
.item__slider .text{
    /* Header/H3: 24px Medium */
    color: rgb(255, 255, 255);
    font-size: 24px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    padding-top: 27px;
}
.item__slider a{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
}
.item__slider img{
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 373.5px;
    object-fit: contain;
}
.slider__content{
    display: flex;
    flex-direction: column;
    align-items: center;
}
.slider__content .text{
    color: rgb(5, 5, 5);
    font-size: 44px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    padding-bottom: 24px;
    max-width: 1034px;
}
.slider__content .desc{
    color: rgb(85, 98, 114);
    font-size: 24px;
    font-weight: 400;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
}
.slider__content a{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 32px;
    background: rgb(255, 183, 16);
    width: 240px;
    height: 44px;
    margin-top: 24px;

    color: rgb(5, 5, 5);
    font-size: 16px;
    font-weight: 500;
    line-height: 140%;
    letter-spacing: 0%;
    text-align: center;
    position: relative;
    overflow: hidden;
    border: 2px solid transparent;
    transition: all 0.3s ease-in-out;
}

.slider__content a:hover {
  background: transparent;
  border-color: rgb(255, 183, 16);
}

.slider__content a::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: -1;
  height: 100%;
  background: rgb(255, 183, 16);
  transition: all 0.3s ease-in-out;
}

.slider__content a:hover::before {
  transform: translateY(-100%);
}
@media (max-width: 1024px) {
    .slider__content .text{
        font-size: 32px;
    }
    .slider__content .desc{
        font-size: 22px;
    }
    .splide {
        margin-top: 70px;
    }
}
@media (max-width: 768px) {
    .scrollLeftAnimation {
    /* display: block; */
    }
    .slider__content .text{
        font-size: 22px;
    }
    .slider__content .desc{
        font-size: 18px;
    }
    .splide {
    margin-top: 70px;
}
}
</style>